import React from 'react';
import Icon from '../Icons/Icon';
import ProfileActions from './ProfileActions';
import ProfileStore from './ProfileStore';
import MailTo from 'react-mailto';
import ContactMe from '../ContactMe';


export default class ProfileLarge extends React.Component {
	constructor(props){
		super(props);
		this.state = ProfileStore.getState();
		this.onchange = this.onchange.bind(this)
	}

	componentDidMount(){
		ProfileStore.listen(this.onchange);
	}

	componentWillUnmount(){
		ProfileStore.unlisten(this.onchange);
	}

	onchange(state){
		this.setState(state);
	}

    render() {

		let tel = this.state.phone;
		if (tel === null)
			tel = '';
        tel = tel.replace(/\D/g, '');
        tel = tel.trim();
        let telLink = `tel:${tel}`;

        let email = this.state.email;
		if (email === null)
			email = '';
        email = email.trim();
		let emailLink = `mailto:${email}`;
		
		let isEmailHidden = this.state.showEmail ? <div className="email-link">
		<span className="text-primary">{/*<i><strong>{this.props.resources["PWS.Globals.EmailAbbr"]}:</strong></i>*/}</span>&nbsp;
		{/*<MailTo className="text-primary" email={this.state.email}>{this.state.email}</MailTo>*/}
			<a href={emailLink}><span className="emailIcon"></span>{this.state.email}</a>
	</div>:<div></div>;
    let isMobilePhoneHidden =this.state.showMobilePhone ?<div className="phone-number" tabIndex="0">
	<span className="text-primary">{/*<i><strong>{this.props.resources["PWS.Globals.PhoneAbbr"]}:</strong></i>*/}</span>&nbsp;
	 <a href={telLink}><span className="phoneIcon"></span>{this.state.phone}</a>
</div>:<div></div>;

		return(
			<div className="my-story-area site-container col-100 clearfix">
		        <div className="my-story-img col-40 tablet-col-30 mobile-col-100 clearfix">
					<div>
						<img src={window.jenkon.activityCenterAvatarUrl} alt={this.state.name} />
					</div>
					<SocialIcons social={this.state.social} />
				</div>

		        <div className="my-story-message-area col-60 tablet-col-70 mobile-col-100 clearfix">
					<div className="my-story-header-area clearfix">
						<h1 className="simple-section-header primary-text" tabIndex="0" dangerouslySetInnerHTML={{ __html:this.props.resources["PWS.Profile.MyStoryTitle"]}}></h1>
						<div className="section-title" tabIndex="0">{this.state.name}</div>
						<div className="my-story-consultant-title" tabIndex="0">{this.state.title}</div>
					</div>
					<div className="phone-email clearfix">
					{isEmailHidden}
						{isMobilePhoneHidden}
					</div>
					<div className="my-story-teaser" tabIndex="0">
						<strong></strong>
					</div>
			        <div className="my-story-message" tabIndex="0" dangerouslySetInnerHTML={{__html: this.props.resources['ActivityCenter.' + window.jenkon.activityCenter + '.MyStory']}}></div>
                    <ContactMe resources={this.props.resources} />
				</div>
			</div>
		)
	}
}

class SocialIcons extends React.Component {
	constructor(props) {
		super(props);
	}

	createIcons(Icon, i){
		let iconData = {
			Size: 26,
			Fill: "",
			name: Icon.code
		}
		return(
			<li className="social-icon">
				<a href={Icon.socialUrl} target="_blank">
					<Icon iconData={iconData} inline={true} />
					<span className="visuallyhidden">{Icon.code}</span>
				</a>
			</li>
		)
	}

	render() {
		if(this.props.social.length == 0) return null;
		return(
			<ul className="social-icons clearfix">
				{this.props.social.map(this.createIcons.bind(this))}
			</ul>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Profile/ProfileLarge.js